import React, { useState } from "react";
import FAQcontent from './Data/FAQ';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="home-faq flex flex-col items-center justify-center gap-20 py-20">
      <div className="textfont text-3xl font-bold mb-8">FAQs</div>
      <div className="w-full max-w-3xl space-y-4">
        {FAQcontent.rows.map((item, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-xl overflow-hidden shadow"
          >
            <button
              className="w-full flex justify-between items-center px-6 py-4 text-left font-semibold text-lg"
              onClick={() => toggleFAQ(index)}
            >
              {item.title}
              <span className="ml-4">{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && (
              <div className="px-6 pb-4 text-gray-600">{item.content}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
